import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APIResponse } from 'src/app/core/models/api-response';
import { environment } from 'src/environments/environment';
import { ICatalog } from '../../catalogs/models/catalogs.models';

@Injectable({
  providedIn: 'root',
})
export class WishlistService {
  constructor(private http: HttpClient) {}

  public listAllWishlist(): Observable<APIResponse<ICatalog>> {
    return this.http.get<APIResponse<ICatalog>>(environment.BASE_URL_API + 'retailers/wishlist');
  }

  public ToggleWishlist(id: number): Observable<APIResponse<ICatalog>> {
    return this.http.post<APIResponse<ICatalog>>(
      `${environment.BASE_URL_API}retailers/wishlist/${id}`,
      {}
    );
  }
}
